import React, { useRef } from "react"
import "./header-consulting-room.scss"
// import { Link } from 'gatsby';

const useMountEffect = fun => React.useEffect(fun, [])

const HeaderConsultingRoom = props => {
  const tabContainer = useRef(null)
  useMountEffect(() => {
    if (tabContainer.current) {
      tabContainer.current.scrollTo(800, 0)
    }
  }) // Scroll on mou
  const { mobile, banner, menu, title } = props
  const [pageLoad, setpageLoad] = React.useState(false)
  const [isShowSexologist, setIsShowSexologist] = React.useState(false)

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g, "T")
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  React.useEffect(() => {
    if (
      process.env.LOCALE === "es-CO" &&
      localStorage.getItem("TOKEN_INFO") &&
      localStorage.getItem("USER_INFO") &&
      calculateAge() >= 18
    ) {
      setIsShowSexologist(true)
    }
  }, [])

  React.useEffect(() => {
    setpageLoad(true)
  }, [])

  return (
    <div className="f-header-consulting-room">
      <img
        alt={banner[0].description}
        src={
          pageLoad
            ? banner[mobile ? 1 : 0].file.url
            : banner[mobile ? 1 : 0].fixed.base64
        }
        height={banner[mobile ? 1 : 0].file.details.image.height}
        className="f-header-consulting-room-banner"
      />
      <div className="f-header-consulting-room-title">
        <span>CONSULTORIOS</span>
        <h1>{title}</h1>
      </div>
      <div
        className="f-header-consulting-room-nav"
        ref={title === "Ginecóloga" ? tabContainer : null}
      >
        {menu.map((category, index) => {
          var color
          if (category.titulo === "Ginecóloga") {
            color = "purple"
          } else if (category.titulo === "Sexóloga") {
            color = "pink"
          } else if (category.titulo === "Bullying") {
            color = "black"
          } else {
            color = "blue"
          }
          if (category.titulo === "Sexóloga" && !isShowSexologist) {
            return null
          }
          return (
            <a
              key={index}
              className="f-header-consulting-room-nav-link"
              href={"/entre-nosotras/consultorios/" + category.slug}
            >
              <div
                className={
                  category.titulo === title ? "active " + color : color
                }
              >
                <img
                  alt={category.imagenMiniatura.description}
                  src={
                    pageLoad
                      ? category.imagenMiniatura.file.url
                      : category.imagenMiniatura.fixed.base64
                  }
                />
                <h2>{category.titulo}</h2>
              </div>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default HeaderConsultingRoom
